__turbopack_context__.v({
  "blok-big-title": "BundleBlok-module__VYtn5q__blok-big-title",
  "blok-subtitle": "BundleBlok-module__VYtn5q__blok-subtitle",
  "blok-title": "BundleBlok-module__VYtn5q__blok-title",
  "category": "BundleBlok-module__VYtn5q__category",
  "left": "BundleBlok-module__VYtn5q__left",
  "left__inner": "BundleBlok-module__VYtn5q__left__inner",
  "main__grid": "BundleBlok-module__VYtn5q__main__grid",
  "overtitle__wrapper": "BundleBlok-module__VYtn5q__overtitle__wrapper",
  "right": "BundleBlok-module__VYtn5q__right",
  "root": "BundleBlok-module__VYtn5q__root",
  "subtitle": "BundleBlok-module__VYtn5q__subtitle",
  "title": "BundleBlok-module__VYtn5q__title",
  "title__wrapper": "BundleBlok-module__VYtn5q__title__wrapper",
});
